<template>
<div>
    <el-skeleton style="width: 100%" animated>
        <template slot="template">
            <el-skeleton-item v-if="tableHeader" class="mb-3" variant="rect" :style="`width: 95%; height: 24px;`" />
            <div class="mb-2" v-for="(index) in rows" :key=index>
                <el-skeleton-item variant="rect" :style="`width: 100%; height: ${rowHeight}px;`" />
            </div>
        </template>
    </el-skeleton>    
</div>
</template>

<script>
export default {
    props: {
        rows: {
            type: Number,
            required: false,
            default: 20
        },
        rowHeight: {
            Type: String,
            required: false,
            default: '62'
        },
        tableHeader: {
            type: Boolean,
            required: false,
            default: true
        }
    },
}
</script>

<style>

</style>